"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormSelectCreatable = void 0;

var _react = _interopRequireDefault(require("react"));

var _select = require("./select.styled");

var _reactUforms = require("react-uforms");

var _selectElements = require("./select-elements");

var _select2 = require("./select");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormSelectCreatable = function FormSelectCreatable(props) {
  var defaultCreateMessage = function defaultCreateMessage(inputValue) {
    return "Create ".concat(inputValue);
  };

  var id = props.id,
      name = props.name,
      hideError = props.hideError,
      disabled = props.disabled,
      required = props.required,
      options = props.options,
      _onChange = props.onChange,
      instanceId = props.instanceId,
      placeholder = props.placeholder,
      optionIcon = props.optionIcon,
      _onBlur = props.onBlur,
      isMulti = props.isMulti,
      isClearable = props.isClearable,
      menuPlacement = props.menuPlacement,
      isSearchable = props.isSearchable,
      showMultiOptionsCount = props.showMultiOptionsCount,
      _props$createMessage = props.createMessage,
      createMessage = _props$createMessage === void 0 ? defaultCreateMessage : _props$createMessage;
  var Option = _selectElements.OptionMultiple;

  var validateNewOption = function validateNewOption(inputValue, selectValue, selectOptions) {
    var exactValueExists = selectOptions.find(function (option) {
      return option.value === inputValue;
    });
    var valueIsNotEmpty = inputValue.trim().length;
    return !exactValueExists && valueIsNotEmpty;
  };

  return /*#__PURE__*/_react.default.createElement(_reactUforms.CustomField, {
    name: name,
    hideError: hideError
  }, function (_ref) {
    var getValue = _ref.getValue,
        setValue = _ref.setValue,
        setTouched = _ref.setTouched,
        getErrors = _ref.getErrors;
    var defaultValue = getValue() ? (0, _select2.formatDefaultValues)(getValue(), options) : undefined;
    return /*#__PURE__*/_react.default.createElement(_select.FormSelectStyled, {
      defaultValue: defaultValue,
      formatCreateLabel: createMessage,
      components: {
        DropdownIndicator: _selectElements.DropdownIndicator,
        ClearIndicator: _selectElements.ClearIndicator,
        NoOptionsMessage: _selectElements.NoOptionsMessage,
        Option: Option,
        MultiValueRemove: _selectElements.MultiValueRemove,
        MultiValueContainer: _selectElements.MultiValueContainer
      },
      isCreatable: true,
      closeMenuOnSelect: false,
      hideSelectedOptions: false,
      isDisabled: disabled,
      value: getValue() ? (0, _select2.formatDefaultValues)(getValue(), options) : null,
      className: "react-select-container",
      classNamePrefix: "react-select-creatable",
      onChange: function onChange(newValue, action) {
        var value = undefined;

        if (newValue) {
          value = Array.isArray(newValue) ? newValue.map(function (item) {
            return item.value;
          }) : newValue.value;
        }

        setValue(value, function () {
          if (_onChange) {
            _onChange(newValue, action);
          }
        });
      },
      onBlur: function onBlur(event) {
        if (_onBlur) {
          _onBlur(event);
        }

        setTouched();
      },
      instanceId: instanceId || name,
      isValidNewOption: validateNewOption,
      error: Array.isArray(getErrors()) && getErrors().length > 0,
      id: id,
      menuPlacement: menuPlacement,
      name: name,
      required: required,
      options: options,
      placeholder: placeholder,
      optionIcon: optionIcon,
      ["onBlur"]: _onBlur,
      isMulti: isMulti,
      isClearable: isClearable,
      isSearchable: isSearchable,
      showMultiOptionsCount: showMultiOptionsCount && isMulti
    });
  });
};

exports.FormSelectCreatable = FormSelectCreatable;
FormSelectCreatable.defaultProps = {
  IsMulti: false,
  menuPlacement: 'auto',
  hideError: false
};
FormSelectCreatable.displayName = 'FormSelectCreatable';